module.exports = __webpack_public_path__ + "static/headline-md.84d979f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/headline-md.jpg
// module id = 474
// module chunks = 114276838955818